import LoadingIndicator from "../../components/LoadingIndicator";
import { useTranslation } from "react-i18next";
import Table from "../../components/Table/Table";
import { useListActiveWorkoutsHistoryQuery } from "src/graphql";
interface HistoryWorkoutsScreenProps {

}

const HistoryWorkoutsScreen: React.FC<HistoryWorkoutsScreenProps> = () => {

    const { loading, error, data } = useListActiveWorkoutsHistoryQuery();


    const { t } = useTranslation();

    if (loading) {
        return <LoadingIndicator />
    }

    if (error) {
        return <p>{error.message}</p>
    }


    return (
        <section>
            <article>
                <h1>{t("Your workouts history")}</h1>
                {data?.listActiveWorkoutsHistory?.items?.length ?
                    <Table
                        headers={[t("Workout Name"), t("Finished at")]}
                        data={data?.listActiveWorkoutsHistory?.items?.map((item, index) => [
                            item.name,
                            <>
                                <p>{new Date(item.end_at!).toLocaleDateString('en-GB')}</p>
                                <p>{new Date(item.end_at!).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</p>
                            </>
                        ])} />

                    :

                    <p>לא קיים אימון בהיסטוריה</p>}


            </article>
        </section>
    );
}

export default HistoryWorkoutsScreen;